// İşlem Hareketini Değiştir (ödeme yöntemi değişimi) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.transactionPaymentMethodChange';

export const transactionPaymentMethodChangeGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'İşlem hareketi nasıl değiştirilir?'),
  intro: t(`${G}.intro`, 'Geçmiş bir cari hareketin ödeme yöntemini Nakit ile POS arasında değiştirirsiniz. Pencere dört adımda ilerler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve adımlar'),
    body: t(`${G}.regions.body`, 'Adım içeriği'),
    footer: t(`${G}.regions.footer`, 'Geri / Devam'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. İşlem bilgilerini kontrol edin'),
      text: t(`${G}.s1.text`, 'İlk adımda Cari Hesap, İşlem Tutarı, İşlem Tarihi, İşlem Açıklaması ile Mevcut ve Hedef Ödeme Yöntemi görünür. Hedef yöntem otomatik belirlenir: mevcut yöntem Nakit ise hedef POS, diğer tüm yöntemlerde hedef Nakit olur.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Hedef hesabı seçin'),
      text: t(`${G}.s2.text`, 'Hedef Nakit ise "Hedef Kasa Seçin", hedef POS ise "Hedef Banka Hesabı Seçin" alanından hesap seçin. Listede yalnız işlemle aynı para birimindeki aktif kasalar / banka hesapları çıkar. Hareketin şu anki kasası veya bankası "Otomatik Tespit Edildi" kutusunda gösterilir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Hesap seçilmeden "Devam" düğmesi açılmaz.'),
        t(`${G}.s2.tip2`, 'İşlem Açıklaması isteğe bağlıdır; boş bırakılırsa "… carisi için ödeme yöntemi değişimi: Nakit -> Pos" gibi bir açıklama oluşturulur.'),
        t(`${G}.s2.tip3`, 'Satış Ekranı seçimi isteğe bağlıdır ve yalnız onay özetinde gösterilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Özeti onaylayın'),
      text: t(`${G}.s3.text`, 'Onay adımında cari, tutar, eski → yeni ödeme yöntemi ve seçilen kasa / banka hesabı özetlenir. Bu işlem geri alınamaz; emin değilseniz "Geri" ile dönün veya "İptal" ile kapatın.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kayıt, cari hareketteki ödeme yöntemini değiştirir; kasaya veya bankaya ayrıca giriş / çıkış hareketi yazmaz. Para gerçekten kasadan bankaya (veya tersine) geçtiyse bunu Kasa → Banka Transferi gibi ilgili ekrandan ayrıca kaydedin ve bakiyeleri Kasa / Banka hareket raporundan kontrol edin.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. İşlemi başlatın'),
      text: t(`${G}.s4.text`, '"İşlemi Başlat" değişikliği kaydeder; son adımda İşlem Logları listesi ve sonuç ("İşlem başarıyla tamamlandı!" veya hata mesajı) görünür. "Bitir" ile pencereyi kapatın, hareket listesi yenilenir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Eski sistemden aktarılmamış (sayısal numarası olmayan) hareketler değiştirilemez; önce verilerin aktarılması gerekir.'),
      ],
    },
  ],
});
